import React, { Component } from 'react';

import { Header, Navbar, NavPills } from '@C';
import { RouteSetup } from '@C/Admin/Packages';
import ErrorBoundary from '@C/Error';
import { authService } from '@S';

const routes = [
  // {
  //   name: 'Basic',
  //   path: '/packages/basic',
  // },
  // {
  //   name: 'Standard',
  //   path: '/packages/standard',
  // },
  {
    name: 'Packages',
    path: '/subscription/packages',
  },
  {
    name: 'Plans',
    path: '/subscription/plans',
  },
];

class Packages extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <main>
        <div className="page-wrapper">
          <Header title="Referral program" />
          <Navbar />
          <div className="page-content">
            <section className="page-components">
              <div className="page-title">
                <h1> Subscription Plans</h1>
              </div>
              <ErrorBoundary>
                <NavPills routes={routes} />
              </ErrorBoundary>
              <ErrorBoundary>
                <RouteSetup />
              </ErrorBoundary>
            </section>
          </div>
        </div>
      </main>
    );
  }
}

export { Packages };
